import {DomainObject} from 'shared/store';
import {observable, action, computed} from 'mobx';
import _ from 'lodash';
import PublicInterviewSchedule from './PublicInterviewSchedule';

class PublicInterviewInvite extends DomainObject {
  @observable companyName;
  @observable startDate;
  @observable endDate;
  @observable interviewSchedule;
  @observable bookableSlots = [];
  @observable booked;
  @observable eventStartsAt;

  @action merge(other) {
    super.merge(other, {
      interviewSchedule: PublicInterviewSchedule,
      _dates: ['eventStartsAt']
    });
  }

  @computed get logoUrl() {
    return _.get(this, 'links.companyLogo');
  }
}

export default PublicInterviewInvite;
